// Package imports:
import React, { useEffect, useState } from 'react';
import Bugsnag from '@bugsnag/js';
// Component imports:
import Alert from '../../../ui-elements/Alert/Alert';
import Loading from '../../../ui-elements/Loading/Loading';
import DisplayBox from '../../DisplayBox/DisplayBox';
import ConstructionReportBody from './ConstructionReportBody';
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from '../../../services/errorMessages';
// Type imports:
import { ConstructionViewModel } from '../../../types/VehicleTypes';
import { Fetched } from '../../../types/Types';

interface IProps {
	model: ConstructionViewModel;
}

const ViewConstructionProfile: React.FC<IProps> = ({
	model
}) => {
    const [data, setData] = useState<Fetched<ConstructionViewModel>>(model);

    const fetchData = async () => {
        try {
            const url = `${GET_KELDAN_API_URL()}/Vehicle/GetConstructionReport/${model?.id}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }
            });
            if (response.ok) {
                if (response.redirected) {
                    window.location.href = response.url;
                }
                const body : ConstructionViewModel = await response.json();
                setData(body);
            } else {
                setData(new Error(ErrorMessages.RequestFailed));
            }
        } catch (e) {
            if (e instanceof Error) Bugsnag.notify(e);
            setData(new Error(ErrorMessages.NetworkError));
        }
    };

    useEffect(() => {
        fetchData();
    }, []);
    return (
        <div className="main KCL_construction-profile">
            <div className='section__body'>
                <div className='shell'>
                    <h1>Vinnuvélaskýrsla</h1>
                    {data instanceof Error
                        ? <DisplayBox>
                            <Alert type='error' headText={data.message} />
                        </DisplayBox>
                        : data === undefined || data === null
                        ? <DisplayBox>
                            <Loading />
                        </DisplayBox>
                        : data?.report 
                        ? <ConstructionReportBody eventId={model.id.toString()} data={data.report} />
                        : data.reportOld
                        ? <ConstructionReportBody eventId={model.id.toString()} dataOld={data.reportOld} />
                        : null
                    }
                </div>
            </div>
        </div>
    )
}
export default ViewConstructionProfile;